import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { CompanyRequest } from './requests/company.request';
import {
    CompanyDetailResponse, CompanyOptionResponse, CompanyResponse,
} from './responses/company.response';

export class CompanyService extends BaseService {
    protected get resourceName(): string {
        return 'crm/companies';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<CompanyResponse>>> {
        return await this.get<PagedResponse<CompanyResponse>>('paginated' + (filter ?? ''), params);
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: CompanyResponse }>> {
        return await this.get(id);
    }

    public async detail(id: string): Promise<AxiosResponse<{ data: CompanyDetailResponse }>> {
        return await this.get(`${id}/detail`);
    }

    public async create(body: CompanyRequest): Promise<AxiosResponse<{ data: CompanyResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: CompanyRequest): Promise<AxiosResponse<{ data: CompanyResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }

    /// Lista para seletor, em ordem alfabética. A busca do seletor filtra na tela.
    public async options(): Promise<AxiosResponse<{ data: CompanyOptionResponse[] }>> {
        return await this.get('options');
    }
}
